import { motion } from "framer-motion";
import { ArrowDownRight } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "./scroll";

export const Header = () => (
  <motion.header
    initial={{ y: -40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
    className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[#030712]/70 backdrop-blur-xl"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
      <Logo />
      <button
        data-testid="header-contact-button"
        onClick={() => scrollToId("contact")}
        className="group flex items-center gap-2 rounded-full border border-sky-400/30 bg-sky-400/5 px-4 py-2 text-sm text-white transition-colors duration-300 hover:bg-sky-400/15"
      >
        Contact
        <ArrowDownRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-[-45deg]" />
      </button>
    </div>
  </motion.header>
);
